$(document).on('click', '.js-show-more', function(event) {
	var $content = $(this).closest('.js-show-more-container').find('.js-show-more-content');
	$(this).hide();
	$content.slideDown();
});